import { render, staticRenderFns } from "./ProfileTalentPackages.vue?vue&type=template&id=48581c80&scoped=true"
import script from "./ProfileTalentPackages.vue?vue&type=script&lang=js"
export * from "./ProfileTalentPackages.vue?vue&type=script&lang=js"
import style0 from "./ProfileTalentPackages.vue?vue&type=style&index=0&id=48581c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48581c80",
  null
  
)

export default component.exports